import * as React from "react"
import Bgvideo from "../../images/trailer2.mp4"
import {
  MainContainer,
  InnerContainer,
  DateText,
  Heading,
  SubHeading,
} from "./bannerStyles"
import Fade from "react-reveal/Fade"
import Typist from "react-typist"
import { Link } from "gatsby"
import "./neontext.css"
const Banner = () => {
  return (
    <>
      <video
        style={{
          position: "absolute",
          width: "100%",
          left: "50%",
          top: "50%",
          height: "100%",
          objectFit: "cover",
          transform: "translate(-50%,-50%)",
          zIndex: "-1",
        }}
        autoPlay
        loop
        muted
      >
        <source src={Bgvideo} type="video/mp4"></source>
      </video>
      <MainContainer>
        <Fade right>
          <InnerContainer>
            <DateText>{`London, Dec 5th to 10th`}</DateText>

            <Heading>Global Conference on React Js</Heading>

            <SubHeading>
              Make another step forward.Spread the inspiration. Join us at the
              biggest annual event and get ready to learn from the World's
              greatest Experts.
            </SubHeading>
            <Link to="/register">
              <button
                style={{
                  marginTop: "20px",
                  zIndex: "90",
                  backgroundImage:
                    "linear-gradient(to right, #fd8a66 0%, #fd4c72 49%, #fd387c 85%, #fd2384 100%)",
                }}
                class="glow-on-hover"
                type="button"
              >
                REGISTRATION
              </button>
            </Link>
          </InnerContainer>
        </Fade>
      </MainContainer>
    </>
  )
}

export default Banner
